import { Link } from "react-router-dom";
import Header from "../components/Header";

export default function NotFound() {
  return (
    <main className="min-h-screen overflow-hidden bg-[#050505] text-white">
      <Header />

      <section className="relative flex min-h-screen items-center justify-center px-6 py-32 text-center md:px-[7%]">
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,rgba(255,217,120,0.18),transparent_32%),radial-gradient(circle_at_bottom_right,rgba(255,143,107,0.18),transparent_38%)]" />
        <div className="absolute inset-0 bg-[linear-gradient(to_top,#050505_0%,transparent_48%)]" />

        <div className="relative z-10 mx-auto max-w-5xl">
          <p className="mb-4 font-black uppercase tracking-wide text-[#ffb56f]">
            Error 404
          </p>

          <h1 className="outfall-heading text-[clamp(64px,10vw,145px)] leading-[0.9] text-[#ffd978] drop-shadow-[0_0_18px_#ff8f6b]">
            LOST IN
            <br />
            THE OUTFALL.
          </h1>

          <p className="mx-auto mt-7 max-w-2xl text-lg font-bold leading-relaxed text-white md:text-2xl">
            This page does not exist, or it may have been moved during the
            storm.
          </p>

          <div className="mt-8 flex flex-wrap justify-center gap-4">
            <Link to="/home" className="outfall-button">
              Back Home
            </Link>

            <Link
              to="/status"
              className="outfall-button outfall-button-secondary"
            >
              Check Status
            </Link>
          </div>
        </div>
      </section>
    </main>
  );
}
